/**
 * Normalize Yup error paths for single-row / root object validation (e.g. profile editors).
 * Strips leading `undefined.` from object-level tests and uses the leaf segment for dotted paths.
 * @param {string | undefined | null} path
 */
export function normalizeYupFieldPath(path) {
  if (path == null || path === '') return '';
  let p = String(path);
  if (p.startsWith('undefined.')) p = p.slice('undefined.'.length);
  const parts = p.split('.').filter(Boolean);
  return parts.length ? parts[parts.length - 1] : '';
}

/** @param {import("yup").ValidationError | null | undefined} yupErr */
export function yupValidationErrorToFieldMap(yupErr) {
  /** @type {Record<string, string>} */
  const map = {};
  if (!yupErr) return map;
  const inner = yupErr.inner && yupErr.inner.length ? yupErr.inner : null;
  if (inner) {
    for (const err of inner) {
      const key = normalizeYupFieldPath(err.path);
      if (key && err.message) map[key] = err.message;
    }
  } else {
    const key = normalizeYupFieldPath(yupErr.path);
    if (key && yupErr.message) map[key] = yupErr.message;
  }
  return map;
}

/** Keep only string values from an API `errors` object. */
export function pickStringApiFieldErrors(errs) {
  if (!errs || typeof errs !== 'object') return {};
  /** @type {Record<string, string>} */
  const out = {};
  for (const [k, v] of Object.entries(errs)) {
    if (typeof v === 'string' && v) out[k] = v;
  }
  return out;
}
